import React from "react"

import ToggleOn from "@mui/icons-material/GridView"
import ToggleOff from "@mui/icons-material/FormatListBulleted"

const ToggleContext = React.createContext({
  on: true,
})

export const ToggleProvider = ({ children, }) => {
  const [on, setOn,] = React.useState(false)
  const toggle = React.useCallback(() => setOn((oldOn) => !oldOn), [])
  const value = React.useMemo(() => ({ on, toggle, }), [on, toggle,])

  return <ToggleContext.Provider value={value}>{children}</ToggleContext.Provider>
}

export function useToggleContext() {
  const context = React.useContext(ToggleContext)
  if (!context) {
    throw new Error("Toggle compound components cannot be rendered outside the Toggle component")
  }
  return context
}

export const PresentationToggleComponent = () => {
  const { on, toggle, } = useToggleContext()
  const ToggleIcon = on ? ToggleOn : ToggleOff
  return <ToggleIcon onClick={toggle} />
}

export const ToggleConsumer = ToggleContext.Consumer

export default ToggleContext
